import React, { useState, useEffect } from 'react';
import { FcGoogle } from "react-icons/fc";
import { appFirebase, messaging } from '../../firebase/credenciales';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { io } from 'socket.io-client';
import { keyMessenger, urlServer } from '../../config';
import Swal from "sweetalert2";
import './login.css'; // Importar los estilos
import TermsModal from './TermsModal'; // Importar el componente del modal
import { getToken } from 'firebase/messaging';

const auth = getAuth(appFirebase);
const db = getFirestore(appFirebase);

const Login = () => {
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [socket, setSocket] = useState(null);
    const [espera, setEspera] = useState(false);

    useEffect(() => {
        // Conexión al servidor socket.io
        const newSocket = io(urlServer);
        setSocket(newSocket);

        return () => {
            if (newSocket) {
                newSocket.disconnect();
            }
        };
    }, []);

    const handleGoogleLogin = async () => {
        const permission = await Notification.requestPermission();
        let token = "";
        if (permission === 'granted') {
            token = await getToken(messaging, { vapidKey: keyMessenger });
        }

        const provider = new GoogleAuthProvider();
        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const userDocRef = doc(db, 'users', user.uid);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
                Swal.fire('Bienvenido:', user.displayName);
                window.location.href = '/dashboard';
            } else {
                setEspera(true);
                socket.emit('newUser', {
                    uid: user.uid,
                    nombre: user.displayName,
                    correo: user.email,
                    typeUser: 'basic',
                    saldo: 1000,
                    tokenMesseger: token,
                });

                socket.on('authResponse', async (data) => {
                    await Swal.fire(data.message);
                    setEspera(false);
                    window.location.href = '/dashboard';
                });
            }
        } catch (error) {
            Swal.fire("Error al iniciar sesión: " + error.message);
        }
    };

    const handleAcceptTerms = () => {
        setAcceptedTerms(true);
        setShowModal(false);
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>¡Bienvenido!</h2>
                <p>Accede a tu cuenta para empezar a jugar.</p>

                <button className="terms-btn" onClick={() => setShowModal(true)}>
                    Leer Términos y Condiciones
                </button>

                <label className="checkbox-container">
                    Acepto los Términos y Condiciones
                    <input
                        type="checkbox"
                        checked={acceptedTerms}
                        onChange={() => setAcceptedTerms(!acceptedTerms)}
                    />
                    <span className="checkmark"></span>
                </label>

                <button
                    className={`google-login-btn ${acceptedTerms ? '' : 'disabled'}`}
                    onClick={handleGoogleLogin}
                    disabled={!acceptedTerms}
                >
                    <FcGoogle className="google-icon" />
                    Iniciar sesión con Google
                </button>

                {espera && (
                    <div className="espera">Procesando... Por favor, espera.</div>
                )}
            </div>

            {showModal && <TermsModal onAccept={handleAcceptTerms} onClose={() => setShowModal(false)} />}
        </div>
    );
};

export default Login;
